import { amber, green } from '@material-ui/core/colors'

const styles = (theme) => ({
  success: {
    backgroundColor: green[600],
  },

  error: {
    backgroundColor: theme.palette.error.dark,
    marginTop: '51px !important',
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
})

export default styles
